import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

type LumButtonSemanticVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'link'
  | 'dotted';
type LumButtonSizeVariant = 'small' | 'medium' | 'large';

@Component({
  selector: 'lum-ui-button',
  templateUrl: './ui-button.component.html',
  styleUrls: ['./ui-button.component.scss'],
})
export class UiButtonComponent implements OnInit, OnChanges {
  // TODO: Change to btnType
  @Input() type :LumButtonSemanticVariant = 'primary';
  @Input() disabled :boolean = false;
  /** @deprecated Use `type` instead. */
  @Input() backgroundColor ?:string;
  @Input() size :LumButtonSizeVariant = 'medium';
  @Input() cssClasses :string = '';
  @Input() loading :boolean = false;
  @Input() submit :boolean = false;
  /** @deprecated Use component content instead. */
  @Input() label :string = '';

  @Output() clickEvent = new EventEmitter<Event>();

  isSubmit :boolean = false;
  classes :string[] = [];

  ngOnInit() {
    this.#updateIsSubmit();
    this.#updateClasses();
  }

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes.submit) {
      this.#updateIsSubmit();
    }
    if (changes.type || changes.size || changes.cssClasses) {
      this.#updateClasses();
    }
  }

  #updateClasses() {
    const semanticClass = `lum-button--${this.type}`;
    const sizeClass = `lum-button--${this.size}`;

    this.classes = [sizeClass, semanticClass, this.cssClasses];
  }

  #updateIsSubmit() {
    const isSubmit = this.submit != null && ![false, 'false'].includes(this.submit);

    if (this.isSubmit !== isSubmit) {
      this.isSubmit = isSubmit;
    }
  }
}
